module.exports = __webpack_public_path__ + "img/public/SiteIcons/editStepTwo.svg?fb5c9d3f";